<template>
  <odds-even-table
    v-if="hasHdaList"
    :list="bettingState.hdaList"
    @click:match="onClickMatch"
    @click:odds="onClickOdds"
  />
  <not-found-card v-else />
</template>

<script lang="ts">
import { computed, type ComputedRef, defineComponent, onMounted } from 'vue';
import OddsEvenTable from '@/components/Betting/OddsEvenTable.vue';
import { useSetTicket } from '@/composition/set-ticket';
import type { TeamSelected } from '@/interfaces/TeamSelected.interface';
import type { MatchSelected } from '@/interfaces/Ticket.interface';
import NotFoundCard from '@/components/NotFoundCard.vue';
import { useBettingStore } from '../store/betting';
import { OddsType } from '../constants/OddsType.enum';

export default defineComponent({
  name: 'ContainerOddsEvenTable',
  components: {
    OddsEvenTable,
    NotFoundCard,
  },
  setup() {
    const bettingStore = useBettingStore();

    onMounted(() => {
      bettingStore.getOddsList(OddsType.HDA);
    });

    const bettingState = computed(() => bettingStore.$state);

    const hasHdaList: ComputedRef<boolean> = computed(
      () => bettingState.value?.hdaList?.length > 0
    );

    const { useSetTicketInputList, useSetSelectedTicketInputList } =
      useSetTicket();

    const onClickMatch = (matchItem: MatchSelected) => {
      return useSetTicketInputList(matchItem);
    };

    const onClickOdds = (newOddsItem: TeamSelected) => {
      return useSetSelectedTicketInputList(newOddsItem);
    };

    return {
      bettingState,
      onClickMatch,
      onClickOdds,
      hasHdaList,
    };
  },
});
</script>

<style></style>
